export enum ReportType {
  FLOW_STATUS = 0,
  EXTERNAL_USER_TASK = 1
}
